// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__3f5th","load5":"Spinner_load5__18w_I"};